<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">{{ witness ? 'Edit' : 'Add' }} Witness</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <div class="col-lg-6">
              <selectlist
                :options="titles"
                v-model="form.title_id"
                label="Title"
                name="title"
                helper="Please select the title for the witness"
                placeholder="Please Select"
              ></selectlist>

              <inputbox
                v-model="form.first_name"
                name="first_name"
                label="First Name"
                helper="Please enter the first name of the witness"
              ></inputbox>

              <inputbox
                v-model="form.last_name"
                name="last_name"
                label="Last Name"
                helper="Please enter the last name of the witness"
              ></inputbox>

              <inputbox
                v-model="form.telephone"
                name="telephone"
                label="Telephone"
                helper="Please enter a telephone number for the witness"
              ></inputbox>

              <inputbox
                v-model="form.email_address"
                name="email"
                label="Email Address"
                type="email"
                helper="Please enter an email address for the witness"
              ></inputbox>
            </div>
            <div class="col-lg-6">
              <address-lookup
                :address="address"
                v-on:address="setAddress"
              ></address-lookup>

              <toggleswitch
                :labels="true"
                name="corroborate"
                label="Corroborate Clients Version of Events?"
                helper="Does the witnesses version of events corroborate with the clients version of events?"
                v-model="form.corroborate"
              ></toggleswitch>
            </div>
          </div>
          <div class="card-footer text-right">
            <button
              class="btn btn-danger btn-raised float-left"
              name="delete"
              v-on:click.prevent="deleteWitness"
              v-if="witness"
            >
              <i class="icon icon-delete"></i> Delete
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="cancel"
              v-on:click.prevent="cancel"
            >
              <i class="icon icon-cancel"></i> Back
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="saveWitness"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from './../../../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  props: {
    incident: {
      type: String,
      required: true
    },

    witness: {
      type: String
    }
  },

  data() {
    return {
      client: null,
      witnessData: null,
      form: new window.Form({
        title_id: null,
        first_name: null,
        last_name: null,
        telephone: null,
        email_address: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        corroborate: null
      }),
      indicator: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    titles() {
      return this.$store.getters['Titles/all'];
    },

    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      if (this.witness) {
        window.Ajax.get(`/incidents/${this.incident}/witnesses/${this.witness}`)
          .then(response => {
            (this.form.title_id = response.data.title_id),
              (this.form.first_name = response.data.first_name),
              (this.form.last_name = response.data.last_name),
              (this.form.telephone = response.data.telephone),
              (this.form.email_address = response.data.email_address),
              (this.form.address_line_one = response.data.address_line_one),
              (this.form.address_line_two = response.data.address_line_two),
              (this.form.city = response.data.city),
              (this.form.postcode = response.data.postcode),
              (this.form.corroborate = response.data.corroborate);
          })
          .catch(error => {});
      }

      window.Ajax.get(`/incidents/${this.incident}/client`)
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {});
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    saveWitness() {
      let url = `/incidents/${this.incident}/witnesses`;
      let method = 'post';

      if (this.witness) {
        url = `${url}/${this.witness}`;
        method = 'put';
      }

      this.form[method](url)
        .then(response => {
          this.$emit('updated', response);
          this.$router.back();
        })
        .catch(response => {
          window.toastify.error('Please complete the required fields');
        });
    },

    deleteWitness() {
      if (this.witness) {
        window
          .swal({
            title: 'Are you sure?',
            text: 'You cannot undo this',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes'
          })
          .then(confirmed => {
            if (confirmed) {
              this.indicator = true;
              window.Ajax.delete(
                `/incidents/${this.incident}/witnesses/${this.witness}`
              )
                .then(response => {
                  this.$emit('deleted', this.witness);
                  this.indicator = false;
                  this.$router.back();
                })
                .catch(error => {
                  this.indicator = false;
                  window.toastify.error(
                    'Sorry, there was an error deleting the witness.'
                  );
                });
            }
          })
          .catch(error => {});
      }
    },

    cancel() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
          this.$router.back();
        })
        .catch(error => {});
    }
  }
};
</script>
